import { api } from "@/lib/api";

export const JOB_STEPS = {
  analyze: ["reading", "extracting", "saving"],
  report: ["collecting", "composing", "purging"],
};

export async function pollJob(jobId, onPhase, intervalMs = 2500) {
  let misses = 0;
  for (;;) {
    await new Promise((r) => setTimeout(r, intervalMs));
    let job;
    try {
      job = (await api.get(`/jobs/${jobId}`)).data;
      misses = 0;
    } catch (err) {
      if (++misses > 10) throw err;
      continue;
    }
    onPhase?.(job.phase);
    if (job.status === "done") return job.result;
    if (job.status === "failed") throw new Error(job.error || "Proses gagal");
  }
}
